import React, { useEffect, useState } from 'react';
import { Typography, Grid,Box } from '@mui/material';
import { getAllMasterTables } from "../../services/MasterTablesService/MasterTableService";
import CardWrapper from "../wrappers/CardWrapper"
const MasterTableListGrid = () => {
  const [tables, setTables] = useState([]);

  useEffect(() => {
    const fetchMasterTables = async () => {
      try {
        const masterTablesList = await getAllMasterTables();
        console.log(masterTablesList);
        setTables(masterTablesList);
      } catch (error) {
        console.error("Error fetching master tables:", error);
      }
    };
    fetchMasterTables();
  }, []);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
    <h1>
      Master Management
    </h1>


      <Grid container spacing={2} sx={{ display: 'flex' }} paddingLeft={4} paddingRight={4}>
        {tables.map((elem, index) => (
          <Grid item sm={12} md={6} lg={4} xl={3} key={index}> 
            <CardWrapper name={elem.name} display_name={elem.display_name} description={elem.description}/>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MasterTableListGrid;
